export enum AuthorityDefault {
  DEFAULT_INTEGRATION_FRAGA = '15.1.1',
  DEFAULT_VIEW_MATRIX = '15.1.2',
  DEFAULT_MANAGERIAL_GRAPHICS = '9.',
}
